// extracted by mini-css-extract-plugin
export default {"carouselContainer":"Carousel_carouselContainer__Or4HK","scrollDownContainer":"Carousel_scrollDownContainer__mo-LS","scrollDownIcon":"Carousel_scrollDownIcon__G7S4a"};